import { Form, Formik, FormikErrors, FormikProps } from 'formik';
import { FormInputWithLabel } from '../../../_core/form/input/form-labelled-input.component';
import { FormButton } from '../../../_core/form/button/form-button.component';
import { IUpdateUserParams } from '../user.types';

interface IUpdateUserFormValues {
  givenName: string;
  familyName: string;
}

interface IRIFormProps {
  givenName?: string | null;
  familyName?: string | null;
  onSubmit: (props: IUpdateUserParams) => Promise<void>;
}

export const UpdateUserForm = ({ givenName, familyName, onSubmit }: IRIFormProps) => {
  const validateForm = (values: IUpdateUserFormValues) => {
    const errors: FormikErrors<IUpdateUserFormValues> = {};

    if (!values.givenName.trim()) errors.givenName = 'Required';
    if (!values.familyName.trim()) errors.familyName = 'Required';

    return errors;
  };

  return (
    <Formik
      initialValues={{ givenName: givenName ?? '', familyName: familyName ?? '' }}
      onSubmit={(values) => onSubmit({ givenName: values.givenName.trim(), familyName: values.familyName.trim() })}
      validate={validateForm}
    >
      {(props: FormikProps<IUpdateUserFormValues>) => (
        <Form className="space-y-4" action="#" method="POST">
          <FormInputWithLabel name="givenName" label="First Name" />
          <FormInputWithLabel name="familyName" label="Last Name" />
          <FormButton loading={props.isSubmitting} text="Update" />
        </Form>
      )}
    </Formik>
  );
};
